import React from 'react'
import { useIntl } from 'react-intl'
import { Column } from 'primereact/column'
import DataTableComp from '../../../components/common/data-table/DataTableComp'
import { bodyParseDate } from '../../../components/common/data-table/column-types/ColumnTypes'
import useHandlerBasicActions from '../../../utils/hooks/useHandlerBasicActions'
import MainCommonView from '../../../components/common/MainCommonView'
import { MarginService } from '../../../services/purchase-fuel/margin/margin.service'
import { formatUnits, formatPercent } from '../../../utils/helpers/common'
import AppSection from '../../../component/layout/AppSection.tsx'
import AppTabMenu from '../../../component/layout/AppTabMenu.tsx'
import { fuelStationsMenu } from '../../../utils/constants/navlinks-Menu'

const Margin = () => {
  const { formatMessage: msg } = useIntl()

  const getAll = async ({ filter, sort, limit, skip }) =>
    MarginService.getAll({ filter, sort, limit, skip })

  const dataFacade = useHandlerBasicActions({
    getAll,
    sortFieldInitial: 'createdAt',
    sortInit: -1,
    rowsPerPageInitial: 100,
  })

  const headerOptions = {
    title: msg({ id: 'margins' }),
    searchOptions: dataFacade?.searchOptions,
  }

  const pagerOptions = {
    ...dataFacade?.pagerOptions,
    totalRecords: dataFacade?.data?.total,
  }

  const dataTable = (
    <DataTableComp
      loading={dataFacade?.loading}
      pagerOptions={pagerOptions}
      tableOptions={{
        className: 'table-with-menu',
        size: 'small',
        value: dataFacade?.data?.resp,
        dataKey: '_id',
        ...dataFacade?.sortOptions,
      }}
      columns={[
        <Column header={msg({ id: 'center' })} field="centerName" sortable />,
        <Column
          field="createdAt"
          header={msg({ id: 'date' })}
          body={(rowData) => bodyParseDate({ date: rowData?.createdAt })}
          sortable
        />,
        <Column
          field="GOA.margin"
          header={msg({ id: 'margin.GOA' })}
          body={(rowData) => formatUnits(rowData?.GOA?.margin)}
          sortable
        />,
        <Column
          field="GOA.percentage"
          header={msg({ id: 'percentage.GOA' })}
          body={(rowData) => formatPercent(rowData?.GOA?.percentage)}
          sortable
        />,
        <Column
          field="G95.margin"
          header={msg({ id: 'margin.G95' })}
          body={(rowData) => formatUnits(rowData?.G95?.margin)}
          sortable
        />,
        <Column
          field="G95.percentage"
          header={msg({ id: 'percentage.G95' })}
          body={(rowData) => formatPercent(rowData?.G95?.percentage)}
          sortable
        />,
      ]}
    />
  )

  return (
    <AppSection
      header={<AppTabMenu options={fuelStationsMenu} />}
      headerOptions={headerOptions}
      dataFacade={dataFacade}
    >
      {dataTable}
    </AppSection>
  )
}

export default Margin
